import*as React from'react';/**
 * @ignore - internal component.
 */var FormControlContext=/*#__PURE__*/React.createContext();if(process.env.NODE_ENV!=='production'){FormControlContext.displayName='FormControlContext';}export default FormControlContext;